class Dialog {
  constructor (nameSpace = 'wh-dialog') {
    this.nameSpace = nameSpace
  }
  // 创建容器
  createContainer () {
    let container = document.createElement('div');
    return container;
  }
  toast (options) {
    let opt = {
      message: '',
      duration: 1000,
    };

    if(typeof options === 'string') {
      opt.message = options
    } else if (typeof options === 'object') {
      opt = Object.assign(opt, options)
    }
    return new Promise((resolve, reject) => {
      let container = this.createContainer();
      // 添加类名，用于主动移除
      container.className = 'weui-toast-dialog';
      // 添加固定结构
      container.innerHTML = `
      <div class="sz-toast">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast weui-animate-fade-in" style="min-height: 2.6em;line-height: 2.6em;">
          ${opt.message}
        </div>
      </div>
      `

      // 绑定事件
      let toastContent = container.querySelector(`.weui-toast`);
      setTimeout(() => {
        toastContent.classList.remove('weui-animate-fade-in');
        toastContent.classList.add('weui-animate-fade-out');
      }, opt.duration)
      // 移除Dom
      setTimeout(() => {
        container.remove();
        resolve();
      }, opt.duration + 300);
      
      // 移除上一个toast
      let lastContainer = document.querySelector('.weui-toast-dialog');
      lastContainer && lastContainer.remove();

      // 添加最新的toast到页面中
      document.body.appendChild(container)
    })
    
  }
  confirm () {

  }
  // 动作列表
  actionSheet (title, actionList) {
    let container = this.createContainer();
    // 添加固定结构
    container.innerHTML = `
    <div>
      <div class="weui-mask weui-animate-fade-in"></div>
      <div class="weui-actionsheet weui-animate-slide-up">
        <div class="actionsheet__title" style="height:1.3rem;background:#fff;border-bottom: 1px solid #e5e5e5;text-align:center;font-size:0.36rem;line-height:1.3rem;color:#9b9b9b;">${title || ''}</div>
        <div class="weui-actionsheet__menu"></div> 
        <div class="weui-actionsheet__action"></div>
      </div>
    </div>
    `
    if(!title && ![0, '0'].includes(title)) {
      container.querySelector('.actionsheet__title').remove();
    }

    // 生成动作列表
    let oActionList = ((_actionList) => {
      let oFragment = document.createDocumentFragment();
      _actionList.forEach(item => {
        // 创建动作承载元素
        let actionItem = document.createElement('div');
        actionItem.classList.add('weui-actionsheet__cell');
        actionItem.innerHTML = item.label;
        actionItem.addEventListener('click', () => {
          document.querySelector('.weui-mask').classList.add('weui-animate-fade-out')
          document.querySelector('.weui-actionsheet').classList.add('weui-animate-slide-down')
          setTimeout(() => {
            container.remove();
          },500)
        });
        actionItem.addEventListener('click', item.onClick);
        oFragment.appendChild(actionItem);
      });
      return oFragment;
    })(actionList)
    // 生成取消按钮
    let oCancelBtn = (() => {
      let actionItem = document.createElement('div');
      actionItem.classList.add('weui-actionsheet__cell');
      actionItem.innerHTML = '取消';
      actionItem.addEventListener('click', () => {
        document.querySelector('.weui-mask').classList.add('weui-animate-fade-out')
        document.querySelector('.weui-actionsheet').classList.add('weui-animate-slide-down')
        setTimeout(() => {
          container.remove();
        },500)
      });
      // 点击遮罩层关闭
      container.querySelector('.weui-mask').addEventListener('click', () => {
        container.querySelector('.weui-mask').classList.add('weui-animate-fade-out')
        container.querySelector('.weui-actionsheet').classList.add('weui-animate-slide-down')
        setTimeout(() => {
          container.remove();
        },500)
      });
      return actionItem;
    })()

    
    container.querySelector('.weui-actionsheet__menu').appendChild(oActionList);
    container.querySelector('.weui-actionsheet__action').appendChild(oCancelBtn);
    document.body.appendChild(container)
  }
}

export default {
  install: (Vue, options) => {
    Vue.prototype.$dialog = new Dialog();
  }
}